<ng-container *notInProductCode="productCode.SGB">
  <ng-container *ifScreenSize="screenType.Desktop">
    <div class="banner" role="banner"></div>
  </ng-container>

  <fgb-page-header [backButtonLink]="'/'" [pageTitle]="'account.page.title'"></fgb-page-header>

  <div class="container mt-lg-4 mt-0">
    <div class="row">
      <ng-container *ifScreenSize="screenType.Desktop">
        <div class="col-12 col-lg-6">
          <h5 class="text-start mb-2 mt-lg-0">{{ 'account.member.card.title' | translate }}</h5>
          <fgb-member-card [showSeating]="true"></fgb-member-card>
        </div> </ng-container
      >-
      <div class="col-12 col-lg-6 pt-lg-0">
        <h5 class="text-start details-title text-white">{{ 'account.details.title' | translate }}</h5>
        <fgb-account-details></fgb-account-details>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *inProductCode="productCode.SGB">
  <fgb-not-found-page></fgb-not-found-page>
</ng-container>
